export default "__VITE_ASSET__B2e2XbgP__"